import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { Form } from './FormRecoverPassword';
import { fetchRecoverPassword } from '@app/src/views/Login/login/state/recoverPassword/actions';
import * as selectUser from '@app/src/views/Login/login/state/recoverPassword/selectors';

const FormContainer = reduxForm({
  form: 'RecoverPasswordForm',
  onSubmit (fields, dispatch, { url }) {
    dispatch(fetchRecoverPassword(fields, url));
  }
})(Form);

const selector = formValueSelector('RecoverPasswordForm');

const mapStateToProps = state => ({
  code: selectUser.getCode(state),
  errorMessage: selectUser.getErrorMessage(state),
  isFetching: selectUser.getIsFetching(state),
  userMail: selector(state, 'email')
});

const FormRecoverPasswordContainer = connect(
  mapStateToProps
)(FormContainer)

export default FormRecoverPasswordContainer;
